import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { ModelRow } from "@mcleod/core";
import { DriverMessageType, DriverSendMessage } from "../../DriverSendMessage";

export class RowActionSendMessage extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonSendEmail;
    }

    override getButtonId(): string {
        return "buttonSendEmail";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["movement_id", "driver1_id", "driver1_name"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];
        const movementId = modelRow.getString("movement_id");
        if (movementId == null) {
            this.addReason(reasonMap, "no_movement", "No movement information found for this record.");
        }
        if ("D" === modelRow.get("move_status")) {
            this.addReason(reasonMap, "move_status", "Cannot send a message for a load that is already delivered.");
        }
    }

    override execute(props: PlanningTableRowActionProps) {
        const modelRow = props.selectedRows[0]?.data as ModelRow;
        DriverSendMessage.openSlideout({
            movementId: modelRow?.getString("movement_id"),
            messageType: DriverMessageType.EMAIL,
            driverId: modelRow?.getString("driver1_id"),
            driverName: modelRow?.getString("driver1_name"),
            driverEditable: true,
            actionSendMessage: true
        });
    }
}
